// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import {Switch} from "antd";

//import styles
import '../../assets/styles/containerStyles/page-add-edit.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import {InputGroup} from "../../components/uiElements/inputGroup";
import {LinkButton} from "../../components/buttons/buttons";
import {LanguageTabs} from "../../components/uiElements/Tabs";
import {MediaFileCard} from "../../components/media/MediaFileCard";

// Import utils
import {
    changeStateField,
    getInputValues,
    getPatchReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
    toggleStateField
} from "../../utils/helperFunctions";
import {mapStateToProps} from "../../redux/mapStateToProps";
import {CreateSlider, UpdateSliderById, GetSliderById} from "../../redux/actions";
import {validateTranslations} from "../../utils/validateTranslations";
import {ACCEPT_IMAGE_TYPES} from "../../constants/acceptedTypes";
import isURL from "validator/es/lib/isURL";
import BlogsSelectorModal from "../../components/BlogsSelectorModal";
import BlogCard from "../../components/cards/BlogCard";

class AddEditSlider extends Component {
    constructor(props) {
        super(props);
        this.translationsFields = [
            'title',
            'subTitle',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                mediaMain: undefined,
                mobileMedia: undefined,
                blog: undefined,
                isHidden: false,
                link: '',
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: props.mainLanguage,
            requestLoading: false,
            blogModalOpen: false,
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.toggleMediaModal = toggleStateField.bind(this, 'mediaModalOpen');
        this.toggleMediaMobileModal = toggleStateField.bind(this, 'mediaMobileModalOpen');
        this.toggleBlogModal = toggleStateField.bind(this, 'blogModalOpen');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);
        this.getBlogItem = this.getBlogItem.bind(this);
        this.onDeleteBlog = this.onDeleteBlog.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.getMediaMobile = this.getMediaMobile.bind(this);
        this.deleteMedia = this.deleteMedia.bind(this);
        this.addEditSlider = this.addEditSlider.bind(this);

    }

    async componentDidMount() {
        const {isEditing, fieldsData} = this.state;
        if (isEditing) {
            const translationsData = {};
            const editingData = await this.props.GetSliderById(this.props.id)
            console.log(editingData);
            if (editingData) {
                Object.keys(fieldsData.translations).forEach(key => {
                    const trItem = editingData?.translations?.find(item => item.language === key);
                    translationsData[key] = {
                        ...fieldsData.translations[key],
                        title: trItem?.title || '',
                        subTitle: trItem?.subTitle || '',
                    };
                });
            }
            const initStateData = {
                translations: translationsData,
                link: editingData?.link || '',
                mediaMain: editingData?.mediaMain,
                mobileMedia: editingData?.mobileMedia,
                blog: editingData?.blog,
                isHidden: editingData?.isHidden,
            }
            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                fieldsData: initStateData,
            });
        }
    }

    getMedia(mediaArray) {
        const {fieldsData, errors, isEditing} = this.state;
        if (isEditing) {
            this.currentData?.mediaMain?.id !== mediaArray[0]?.id
                ? this.updatedDataMap.set("mediaMain", mediaArray[0]?.id)
                : this.updatedDataMap.delete("mediaMain");
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                mediaMain: mediaArray[0],
            },
            errors: {
                ...errors,
                mediaMain: false
            }
        })
    }

    getMediaMobile(mediaArray) {
        const {fieldsData, errors, isEditing} = this.state;
        if (isEditing) {
            this.currentData?.mobileMedia?.id !== mediaArray[0]?.id
                ? this.updatedDataMap.set("mobileMedia", mediaArray[0]?.id)
                : this.updatedDataMap.delete("mobileMedia");
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                mobileMedia: mediaArray[0],
            },
            errors: {
                ...errors,
                mobileMedia: false
            }
        })
    }

    deleteMedia(type) {
        const {fieldsData, isEditing} = this.state;
        if (isEditing) {
            this.currentData?.[type] ?
                this.updatedDataMap.set(type, null) :
                this.updatedDataMap.delete(type);
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: null
            }
        })
    }

    getBlogItem(blogList) {
        const {fieldsData, isEditing} = this.state;

        console.log('getBlogItem', blogList);
        if (isEditing) {
            this.updatedDataMap.set("blog",  blogList?.[0]?.id);
        }

        this.setState({
            fieldsData: {
                ...fieldsData,
                blog: blogList?.[0],
            }
        })
    }

    onDeleteBlog() {
        const {fieldsData, isEditing} = this.state;
        if (isEditing) {
            this.updatedDataMap.set("blog",  null);
        }

        this.setState({
            fieldsData: {
                ...fieldsData,
                blog: undefined,
            }
        })
    }

    async addEditSlider() {
        await this.setState({
            requestLoading: true
        });
        const {sliderType} = this.props
        const {translations, mediaMain, mobileMedia, link, isHidden, blog, type, resourceId} = this.state.fieldsData;
        const translationRequiredFields = []
        const validationTr = validateTranslations(translations, translationRequiredFields)
        // let result = validationTr.result;
        let result = true;
        // const errors = {...validationTr.errors};
        const errors = {};

        // if (!mediaMain) {
        //     errors.mediaMain = true;
        //     result = false;
        // }
        // if (!mobileMedia) {
        //     errors.mobileMedia = true;
        //     result = false;
        // }

        if (!blog && !mediaMain) {
            errors.mediaMain = true;
            result = false;
        }

        if (link && !isURL(link)) {
            errors.link = true;
            result = false;
        }
        if (result) {
            if (!this.state.isEditing) {
                const reqData = {
                    isHidden,
                    type: sliderType,
                    translations: getTranslationData(translations),
                };
                if (link) {
                    reqData.link = link
                }
                if (mediaMain) {
                    reqData.mediaMain = mediaMain.id
                }
                if (mobileMedia) {
                    reqData.mobileMedia = mobileMedia.id
                }
                if (blog) {
                    reqData.blog = blog.id
                }
                // else if (type && resourceId) {
                //     reqData.type = type;
                //     reqData.resourceId = resourceId;
                // }
                this.props.CreateSlider(reqData).finally(() => {
                    this.setState({requestLoading: false});
                })
            } else {
                const trData = getTranslationData(translations);
                const reqData = this.getPatchReqData(trData);
                this.props.UpdateSliderById(this.props.id, reqData)
                    .finally(() => {
                        this.setState({requestLoading: false});
                    });
            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    render() {
        const {
            fieldsData,
            errors,
            languageTab,
            mediaModalOpen,
            mediaMobileModalOpen,
            requestLoading,
            isEditing,
            errorsTabs,
            blogModalOpen,
        } = this.state;
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData.translations[languageTab] || {};

        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել Սլայդեր' : 'Փոփոխել Սլայդերը'}>
            <section className="page-add-edit">
                <div className="fixed-top-right">
                    <label>{!fieldsData.isHidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.isHidden}
                            onChange={(checked) => this.getInputValues({
                                name: "isHidden",
                                value: !checked,
                                haveChanges: this.currentData?.isHidden !== !checked
                            })}/>
                </div>
                <div className={"images-wrapper"}>
                    <div>
                        <div className="top-side">
                            <label>Նկար {!fieldsData.blog && <span className={'required-badge'}>*</span>}</label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.mediaMain ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaModal}
                            />
                        </div>
                        {fieldsData?.mediaMain && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.mediaMain}
                                           customDelete={() => this.deleteMedia("mediaMain")}
                            />
                        </div>}
                    </div>
                    {/*<div>
                        <div className="top-side">
                            <label>Փոքր Նկար </label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.mobileMedia ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaMobileModal}
                            />
                        </div>
                        {fieldsData?.mobileMedia && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.mobileMedia}
                                           customDelete={() => this.deleteMedia("mobileMedia")}
                            />
                        </div>}
                    </div>*/}
                </div>

                <div className={'blog-select-wrapper'}>
                    <div className="top-side">
                        <label>Բլոգ</label>
                        <LinkButton title="Ընտրել Բլոգ"
                                    className={`media-select-btn`}
                                    cb={this.toggleBlogModal}
                        />
                    </div>
                    {fieldsData?.blog && <BlogCard data={fieldsData?.blog}
                                                   viewCard={true}
                                                   onDelete={this.onDeleteBlog}/>}
                </div>
                <InputGroup inputType="input"
                            type="text"
                            label="Հղում"
                            placeholder="Հղում"
                            name="link"
                    // disabled={fieldsData?.blog}
                            value={fieldsData?.link}
                            initValue={this.currentData?.link}
                            error={errors?.link}
                            maxLength={100}
                            onChange={this.getInputValues}/>

                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>
                <div className="slider-wrapper">

                    <InputGroup inputType="input"
                                type="text"
                                label="Անվանում"
                                placeholder="Անվանում"
                                name="title"
                                value={currentData.title}
                                initValue={initData.title}
                                error={errors['title' + languageTab]}
                                maxLength={200}
                        // required={true}
                                onChange={this.getTranslationValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Ենթավերնագիր"
                                placeholder="Ենթավերնագիր"
                                name="subTitle"
                                value={currentData.subTitle}
                                initValue={initData.subTitle}
                                error={errors['subTitle' + languageTab]}
                                maxLength={1000}
                        // required={true}
                                onChange={this.getTranslationValues}/>
                </div>

                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                disabled={isEditing && !this.updatedDataMap.size}
                                cb={this.addEditSlider}/>
                </div>

            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalOpen}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
            <MediaSelectorModal
                isOpen={!!mediaMobileModalOpen}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMediaMobile}
                closeModal={this.toggleMediaMobileModal}/>

            <BlogsSelectorModal
                isOpen={!!blogModalOpen}
                multiSelect={false}
                appendBlogs={fieldsData.blog ? [fieldsData.blog] : []}
                getSelectedBlogs={this.getBlogItem}
                closeModal={this.toggleBlogModal}/>
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    CreateSlider,
    UpdateSliderById,
    GetSliderById
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditSlider)
